import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../firebase';

interface PartnerData {
  id: string;
  name: string;
  imageUrl: string;
}

const fallbackPartners: PartnerData[] = [
  { id: '1', name: 'Garanti BBVA', imageUrl: '' },
  { id: '2', name: 'QNB Finansbank', imageUrl: '' },
  { id: '3', name: 'Vitra', imageUrl: '' },
  { id: '4', name: 'Knauf', imageUrl: '' },
  { id: '5', name: 'İş Bankası', imageUrl: '' },
  { id: '6', name: 'OYAK Çimento', imageUrl: '' },
];

export default function Partners() {
  const [partners, setPartners] = useState<PartnerData[]>(fallbackPartners);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'pages', 'partners'), (docSnap) => {
      if (docSnap.exists() && docSnap.data().items && docSnap.data().items.length > 0) {
        setPartners(docSnap.data().items);
      }
    });
    return () => unsub();
  }, []);

  // Duplicate partners for seamless loop
  const duplicatedPartners = [...partners, ...partners, ...partners];

  return (
    <div className="py-12 bg-gray-50 border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 mb-8 text-center">
        <h3 className="text-2xl font-bold text-gray-800 tracking-tight" style={{ fontFamily: 'Raleway, sans-serif' }}>
          Çözüm Ortaklarımız
        </h3>
        <div className="w-20 h-1 bg-red-600 mx-auto mt-4 rounded-full"></div>
      </div>

      <div className="relative flex whitespace-nowrap">
        {/* Shadow Overlays for depth */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none"></div>

        <motion.div
          className="flex"
          animate={{
            x: ["0%", "-50%"]
          }}
          transition={{
            duration: Math.max(20, partners.length * 5),
            repeat: Infinity,
            ease: "linear",
          }}
        >
          {duplicatedPartners.map((partner, index) => (
            <div
              key={index + partner.id}
              className="flex items-center gap-4 px-12 opacity-60 hover:opacity-100 transition-opacity"
            >
              {partner.imageUrl ? (
                <img src={partner.imageUrl} alt={partner.name} className="h-16 w-auto object-contain mix-blend-multiply grayscale hover:grayscale-0 transition-all duration-300" />
              ) : (
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-gray-200 flex items-center justify-center">
                    <i className="ri-building-line text-2xl text-gray-600"></i>
                  </div>
                  <span className="text-xl font-bold text-gray-700 uppercase tracking-widest truncate" style={{ fontFamily: 'Raleway, sans-serif' }}>
                    {partner.name}
                  </span>
                </div>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
